'use strict';

import { Entity } from '../Entity';
import { GlobConnectureOrgCollection } from '../../Collections/Glob/GlobConnectureOrgCollection';

export class GlobConnectureOrg extends Entity {
  protected id;

  protected orgName;

  protected reference;

  protected url;

  protected urlRelay;

  protected clientId;

  protected application;

  protected partnerId;

  protected apiKey;

  protected apiSecret;

  protected needsUserValidation;

  protected inactive;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.orgName = data.orgName;

    this.reference = data.reference;

    this.url = data.url;

    this.urlRelay = data.urlRelay;

    this.clientId = data.clientId;

    this.application = data.application;

    this.partnerId = data.partnerId;

    this.apiKey = data.apiKey;

    this.apiSecret = data.apiSecret;

    this.needsUserValidation = data.needsUserValidation;

    this.inactive = data.inactive;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getOrgName() {
    return this.orgName;
  }

  public setOrgName(orgName) {
    this.orgName = orgName;

    return this;
  }

  public getReference() {
    return this.reference;
  }

  public setReference(reference) {
    this.reference = reference;

    return this;
  }

  public getUrl() {
    return this.url;
  }

  public setUrl(url) {
    this.url = url;

    return this;
  }

  public getUrlRelay() {
    return this.urlRelay;
  }

  public setUrlRelay(urlRelay) {
    this.urlRelay = urlRelay;

    return this;
  }

  public getClientId() {
    return this.clientId;
  }

  public setClientId(clientId) {
    this.clientId = clientId;

    return this;
  }

  public getApplication() {
    return this.application;
  }

  public setApplication(application) {
    this.application = application;

    return this;
  }

  public getPartnerId() {
    return this.partnerId;
  }

  public setPartnerId(partnerId) {
    this.partnerId = partnerId;

    return this;
  }

  public getApiKey() {
    return this.apiKey;
  }

  public setApiKey(apiKey) {
    this.apiKey = apiKey;

    return this;
  }

  public getApiSecret() {
    return this.apiSecret;
  }

  public setApiSecret(apiSecret) {
    this.apiSecret = apiSecret;

    return this;
  }

  public getNeedsUserValidation() {
    return this.needsUserValidation;
  }

  public setNeedsUserValidation(needsUserValidation) {
    this.needsUserValidation = needsUserValidation;

    return this;
  }

  public isInactive() {
    return this.inactive;
  }

  public setInactive(inactive) {
    this.inactive = inactive;

    return this;
  }
}
